//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';

export default {
  name: 'app',
  methods: {
    ...mapActions('roles', [
      'setToken',
    ]),
  },
  mounted() {
    this.setToken(this.$auth.token);
  },
};



// WEBPACK FOOTER //
// ./src/App.vue?vue&type=script&lang=js&